import React from 'react';
import { Link } from "react-scroll";
import Button from 'react-bootstrap/Button';

// import { Container } from './styles';

function Biologico({vector1, newAttendance, biologico1, arrowUp, arrowDown}) {
    return (
        <div  id="biologico">
            <div className="bodySolucoes sumir" style={{backgroundColor: 'var(--main-white-color)', width: "100%", marginBottom: 50, overflowY: "hidden", overflowX: 'hidden', position: 'relative'}}>
                <img
                src={vector1}
                alt="Vector"
                className='vector'
                />
                <div
                style={{
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 160,
                    lineHeight: 1,
                }}>
                    <p 
                    style={{
                        color: "var(--main-bg-color)", 
                        fontSize: 34, 
                        fontWeight: 700,
                        margin: 20
                    }}>
                        <span style={{fontSize: 20, color: 'var(--main-secondy)'}}>COLETA DE </span><br></br> 
                        RESÍDUO BIOLÓGICO <br></br>
                        <span style={{fontSize: 20, color: 'var(--main-secondy)'}}>E PERFURO CORTANTE</span>
                    </p>
                </div>
                <div className="row" style={{width: "100%"}}>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                        style={{
                            display: "flex",
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            flexDirection: 'column'
                        }}>
                        <div className="row" style={{
                            display: "flex",
                            alignItems: 'center',
                            padding: 40,
                            paddingLeft: 120
                        }}>
                            <p 
                            className='titleText'>
                                Saiba agora todos os detalhes da nossa coleta.
                            </p>
                            <p 
                            className='subTitleText' style={{paddingRight: 30}}>
                                Os resíduos biológicos e perfurocortantes fazem parte do Grupo A e o segundo grupo E e são aqueles tipos de materiais que apresentam riscos à saúde pública e ao meio ambiente.<br></br><br></br>
                                Antes do descarte, contamos com uma área exclusiva e especializada para tratamento do resíduo biológico e perfuro cortante, através de autocláveis.<br></br><br></br>
                                Nosso processo envolve: coleta, tratamento, direcionamento e descarte em aterros devidamente certificados.
                            </p>
                            <div style={{width: '100%', display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: 30}}>
                                <Button style={{
                                    boxShadow: "0px 15.3171px 15.3171px rgba(0, 0, 0, 0.25)",
                                    backgroundColor: "var(--main-bg-color)",
                                    border: 0,
                                }} 
                                variant="secondary"
                                onClick={() => newAttendance('Olá grupo Urbam, solicito orçamento sobre o Resíduo Biológico')}
                                >
                                    ORÇAMENTO | RESÍDUO BIOLÓGICO
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: 20,
                        position: 'relative'
                    }}>
                        <img
                        src={biologico1}
                        alt="Imagem Residuo Biologico"
                        style={{width: "90%", paddingRight: 90}}
                        />
                        <Link
                            activeClass="active"
                            to="extraordinario"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonUpR"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowUp}
                                alt="Seta pra cima"
                            />
                        </Link>
                        <Link
                            activeClass="active"
                            to="quimico"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonDownR"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowDown}
                                alt="Seta pra baixo"
                            />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="bodySolucoes mostrar" style={{backgroundColor: 'var(--main-white-color)', width: "100%", margin: 0, overflowY: "hidden", overflowX: 'hidden', position: 'relative'}}>
                <div
                style={{
                    display: "flex",
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    lineHeight: 1,
                    height: 160,
                }}>
                    <p 
                    style={{
                        color: "var(--main-bg-color)", 
                        fontSize: 34, 
                        fontWeight: 700,
                        margin: 20,
                        marginLeft: 90
                    }}>
                        <span style={{fontSize: 20, color: 'var(--main-secondy)'}}>COLETA DE </span><br></br> 
                        RESÍDUO BIOLÓGICO <br></br>
                        <span style={{fontSize: 20, color: 'var(--main-secondy)'}}>E PERFURO CORTANTE</span>
                    </p>
                </div>
                <div className="row" style={{width: "100%"}}>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative'
                    }}>
                        <Link
                            activeClass="active"
                            to="extraordinario"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonUpL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowUp}
                                alt="Seta pra cima"
                            />
                        </Link>
                        <Link
                            activeClass="active"
                            to="quimico"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonDownL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowDown}
                                alt="Seta pra baixo"
                            />
                        </Link>
                        <img
                        src={biologico1}
                        alt="Imagem Residuo Biologico"
                        style={{width: "94%", paddingLeft: 68}}
                        />
                        
                    </div>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                        style={{
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column'
                        }}>
                        <div className="row" style={{
                            display: "flex",
                            alignItems: 'center',
                            padding: 40,
                            paddingLeft: 60 
                        }}>
                            <p 
                            className='titleText'>
                                Saiba agora todos os detalhes da nossa coleta.
                            </p>
                            <p 
                            className='subTitleText' style={{paddingRight: 30}}>
                            Os resíduos biológicos e perfurocortantes fazem parte do Grupo A e o segundo grupo E e são aqueles tipos de materiais que apresentam riscos à saúde pública e ao meio ambiente.<br></br><br></br>
                                Antes do descarte, contamos com uma área exclusiva e especializada para tratamento do resíduo biológico e perfuro cortante, através de autocláveis.<br></br><br></br>
                                Nosso processo envolve: coleta, tratamento, direcionamento e descarte em aterros devidamente certificados.
                            </p>
                            <div style={{width: '100%', display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: 30}}>
                                <Button style={{
                                    boxShadow: "0px 15.3171px 15.3171px rgba(0, 0, 0, 0.25)",
                                    backgroundColor: "var(--main-bg-color)",
                                    border: 0,
                                }} 
                                variant="secondary"
                                onClick={() => newAttendance('Olá grupo Urbam, solicito orçamento sobre o Resíduo Biológico')}
                                >
                                    ORÇAMENTO | RESÍDUO BIOLÓGICO
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Biologico;